import type { Movie } from '@/mocks/movies';

interface ShareDialogProps {
  movie: Movie;
  open: boolean;
  onClose: () => void;
  onCopied: () => void;
}

const channels = [
  { icon: 'ri-links-line', label: '复制链接', key: 'copy' },
  { icon: 'ri-wechat-line', label: '微信', key: 'wechat' },
  { icon: 'ri-weibo-line', label: '微博', key: 'weibo' },
  { icon: 'ri-message-2-line', label: '短信', key: 'sms' },
];

export default function ShareDialog({ movie, open, onClose, onCopied }: ShareDialogProps) {
  if (!open) return null;

  const shareUrl = `${window.location.origin}/movie-detail/${movie.id}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      // clipboard unavailable — still show feedback
    }
    onCopied();
  };

  return (
    <div
      className="fixed inset-0 z-[85] bg-background-950/85 backdrop-blur-sm flex items-center justify-center px-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-background-900 border border-background-800 p-6 relative"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-md flex items-center justify-center text-foreground-400 hover:text-foreground-100 hover:bg-background-800 transition-colors cursor-pointer"
          aria-label="关闭"
        >
          <i className="ri-close-line text-lg"></i>
        </button>

        <h3 className="text-lg font-semibold text-foreground-50">分享影片</h3>
        <p className="mt-1 text-sm text-foreground-400">把《{movie.title}》分享给同样爱看故事的朋友</p>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {channels.map((channel) => (
            <button
              key={channel.key}
              type="button"
              onClick={handleCopy}
              className="flex flex-col items-center gap-2 py-3 rounded-md bg-background-800/60 border border-background-700/70 hover:border-primary-500/60 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 rounded-md bg-primary-500/12 text-primary-400 flex items-center justify-center">
                <i className={`${channel.icon} text-lg`}></i>
              </span>
              <span className="text-xs text-foreground-300 whitespace-nowrap">{channel.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5">
          <span className="block text-xs text-foreground-400 mb-2">影片链接</span>
          <div className="flex items-center gap-2 p-2 rounded-md bg-background-800 border border-background-700">
            <span className="flex-1 text-xs text-foreground-300 truncate px-2">{shareUrl}</span>
            <button
              type="button"
              onClick={handleCopy}
              className="px-3 py-1.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              复制
            </button>
          </div>
        </div>

        <p className="mt-4 text-xs text-foreground-500">分享为前端演示效果，链接仅在本地生成。</p>
      </div>
    </div>
  );
}